/**
 * Sessionsvakt: användaren ska loggas ut när webbläsaren stängs.
 *
 * Supabase-klienten sparar sessionen i localStorage (filen är autogenererad
 * och kan inte ändras). Därför rensar vi auth-nycklarna manuellt när sidan
 * öppnas i en helt ny webbläsarsession.
 *
 * För att inte logga ut användaren när hen öppnar en extra flik håller vi
 * räkningen på hur många flikar som är öppna i localStorage. Bara när noll
 * flikar var öppna (= webbläsaren har varit stängd) rensas sessionen.
 */

const TAB_MARKER = "hd-tab-active";
const TAB_COUNT_KEY = "hd-open-tabs";

function getTabCount(): number {
  const raw = Number(localStorage.getItem(TAB_COUNT_KEY));
  return Number.isFinite(raw) && raw > 0 ? raw : 0;
}

function clearSupabaseAuth() {
  const keys: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith("sb-") && key.includes("auth-token")) {
      keys.push(key);
    }
  }
  keys.forEach((key) => localStorage.removeItem(key));
}

export function initSessionGuard() {
  try {
    const isExistingTabSession = sessionStorage.getItem(TAB_MARKER) === "1";

    if (!isExistingTabSession) {
      // Ny flik. Om ingen annan flik är öppen har webbläsaren varit stängd.
      if (getTabCount() === 0) {
        clearSupabaseAuth();
      }
      sessionStorage.setItem(TAB_MARKER, "1");
      localStorage.setItem(TAB_COUNT_KEY, String(getTabCount() + 1));
    }

    window.addEventListener("pagehide", () => {
      const next = Math.max(0, getTabCount() - 1);
      localStorage.setItem(TAB_COUNT_KEY, String(next));
    });

    // Om fliken visas igen efter bfcache-återställning, räkna upp på nytt.
    window.addEventListener("pageshow", (event) => {
      if ((event as PageTransitionEvent).persisted) {
        localStorage.setItem(TAB_COUNT_KEY, String(getTabCount() + 1));
      }
    });
  } catch {
    // localStorage/sessionStorage kan vara blockerat – ignorera tyst.
  }
}
